import React from "react";
import { Box, Tooltip } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

/**
 * The × inside a batch tab. A tab is itself a button, so this is not a second
 * tab stop: pointer users click it, keyboard users press Delete on the tab
 * (each tab bar handles that key). The click never reaches the tab, so
 * removing a tab never selects it first.
 */
export default function TabRemoveButton({ label, onRemove, size = 22 }) {
  const stop = (e) => e.stopPropagation();
  return (
    <Tooltip title={label} enterDelay={400} disableInteractive>
      <Box
        component="span"
        role="button"
        tabIndex={-1}
        aria-label={label}
        onMouseDown={stop}
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
          onRemove();
        }}
        sx={{
          ml: 0.25,
          mr: -0.5,
          width: size,
          height: size,
          borderRadius: "50%",
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#94a3b8",
          flexShrink: 0,
          cursor: "pointer",
          transition: "background-color 120ms ease-out, color 120ms ease-out",
          "&:hover": { bgcolor: "#fee2e2", color: "#b91c1c" },
          "@media (prefers-reduced-motion: reduce)": { transition: "none" },
        }}
      >
        <CloseIcon sx={{ fontSize: Math.round(size * 0.64) }} aria-hidden />
      </Box>
    </Tooltip>
  );
}
